import type { TImageElement } from '@shared/dream-components';
import { ImageElement } from '@shared/dream-components';
import type { ReactNode } from 'react';
import useProductMergeTagProcessor from './hooks/useProductMergeTagProcessor';

interface Props {
  node: TImageElement;
  children: ReactNode | ReactNode[];
}

const Image = ({ node, children }: Props) => {
  const { node: nodeToRender } = useProductMergeTagProcessor({ node, children });

  return <ImageElement element={nodeToRender}>{children}</ImageElement>;
};

export default Image;
